<script setup lang="ts">
/**
 * /cv-languages — translating a whole CV with the editor's "Translate"
 * section (MarketingTranslateGuide), then every language a CV can be written
 * in, with an FAQ mirrored into FAQPage structured data.
 */
const { t } = useI18n()
const { faqPageNode } = useJsonLd()

definePageMeta({
  layout: false,
  auth: false,
})

// Its URL in Czech, German and Polish (constants/localizedRoutes.ts).
false && /*#__PURE__*/ defineI18nRoute({ paths: { cs: '/preklad-zivotopisu', de: '/lebenslauf-uebersetzen', pl: '/tlumaczenie-cv' } })

const FAQ_IDS = ['original', 'quality', 'facts', 'headings', 'free'] as const

const faqItems = computed(() =>
  FAQ_IDS.map(id => ({
    id,
    question: t(`translatePage.faq.${id}.q`),
    answer: t(`translatePage.faq.${id}.a`),
  })),
)

const extraNodes = computed(() => [faqPageNode('/cv-languages', faqItems.value)])
</script>

<template>
  <MarketingFeaturePage seo-key="cvLanguages" path="/cv-languages" :extra-nodes="extraNodes">
    <MarketingTranslateGuide />

    <LazyHomepageLanguageSupportSection />

    <MarketingFaqSection
      :title="t('translatePage.faq.title')"
      :items="faqItems"
      name="translate-faq"
    />
  </MarketingFeaturePage>
</template>
